import { AxiosError } from 'axios';
import { Dispatch } from 'redux';
import { FETCH_COMING_CARS } from '../../helpers/constants';
import { request } from '../../helpers/request';
import { ADD_INCOMING_CARS_LIST } from '../types/carListTypes';
import { ICarListingPagination } from '../../interface/car';

export const fetchComingCars = (
    dispatch: Dispatch,
    params?: ICarListingPagination
) => {
    return request
        .getComingCars(params)
        .then((response: any) => {
            dispatch({
                type: FETCH_COMING_CARS,
                payload: response.data ?? []
            });
            dispatch({ type: ADD_INCOMING_CARS_LIST, payload: response?.data });
            return response;
        })

        .catch((err: AxiosError | Error) => {
            return err;
        });
};
